module.exports = __webpack_public_path__ + "img/Ellipse 3.79be1481.png";